import { User } from "contexts/types/application-context-types";
import { MenuItemProps, SubItemProps } from "./menu-array";
import { Router } from "router-manager/parts";

export function checkIsVisible(
  menuItem: MenuItemProps | SubItemProps,
  user: User
): boolean {
  let isVisible = false;
  const { href, subItems } = menuItem;

  if (href) {
    isVisible = Router.getRoute(href)?.checkPermission(user) ?? false;
  } else {
    subItems?.forEach(({ href }) => {
      isVisible =
        isVisible || (Router.getRoute(href)?.checkPermission(user) ?? false);
    });
  }

  return isVisible;
}
